import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
// connect gives as access to state from redux store
import _ from "lodash";
import PropTypes from "prop-types";
import { acceptCookies, logout, resetAuthUser } from "../actions/authActions";
import { changePage } from "../actions/changePageAction";
import { clearErrors } from "../actions/errorActions";
import { getProjects } from "../actions/projectActions";
import { changeLanguage } from "../actions/userActions";
import NavigationLink from "./container/NavigationLink";
import i18n from "./helper/i18n";
// import FilterLinkRed from "./container/FilterLinkRed";
import { Button, Nav, Navbar, NavDropdown } from "react-bootstrap";
import InlineLink from "./container/InlineLink";
import NavigationLinkAbs from "./container/NavigationLinkAbs";
import ProfileLink from "./container/ProfileLink";
import { getLegendTransl } from "./helper/manTrans";
import { Translation } from "./helper/transComp";

class HeaderLoggedOut extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      width: 0,
      height: 0,
      displMenu: false,
      languages: ["en", "de", "fr"],
      currLan: "en",
      register: false,
      login: false,
      images: [],
      isAuthenticated: false,
      isSubPage: false,
      solutions: [
        { trans: "SolutionsSolutions", filter: "solutions" },
        { trans: "SolutionsToDoList", filter: "todolist" },
        { trans: "SolutionsGantt", filter: "gantt" },
        { trans: "SolutionsKanban", filter: "kanban" },
        { trans: "SolutionsWBS", filter: "wbs" },
      ],
      offer: [
        { trans: "HeaderSoftware", filter: "software" },
        { trans: "HeaderFormation", filter: "training" },
        { trans: "HeaderConsulting", filter: "consulting" },
      ]
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    changePage: PropTypes.func.isRequired,
    page: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    getProjects: PropTypes.func.isRequired,
    image: PropTypes.object,
    logout: PropTypes.func.isRequired,
    resetAuthUser: PropTypes.func.isRequired,
    changeLanguage: PropTypes.func.isRequired,
    acceptCookies: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,

    // changeLan: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    let domainPath = "";
    if (window.location)
      if (window.location.pathname) domainPath = window.location.pathname;
    //decide which language to use on start
    let choosenLanguage = "en";

    if (
      !domainPath.includes("emailValidation") &&
      !domainPath.includes("resetPassword")
    ) {
      let subdomain = [];
      subdomain = domainPath.split("/");
      let sLan = "en";
      let sPage = "";
      let subPage = "";
      if (subdomain.length > 0) if (subdomain[0] === "") subdomain.shift();

      if (
        subdomain[0] == "fr" ||
        subdomain[0] == "de" ||
        subdomain[0] == "en"
      ) {
        sLan = subdomain[0].toLocaleLowerCase();
        if (subdomain[1] && subdomain[1] !== "") sPage = subdomain[1];
        i18n.changeLanguage(sLan);
        this.props.changeLanguage(sLan);
        choosenLanguage = subdomain[0];
        if (subdomain[2] && subdomain[2] !== "")
          this.setState({ isSubPage: true });
      } else {
        sPage = subdomain[0].toLocaleLowerCase();
        if (subdomain[1] && subdomain[1] !== "") {
          subPage = subdomain[1].toLocaleLowerCase();
          this.setState({ isSubPage: true });
        }
        if (this.props.user) {
          if (this.props.user.language) {
            if (
              this.props.user.language !== "" &&
              this.props.user.language !== null
            ) {
              if (this.props.user.language == "fr") choosenLanguage = "fr";
              if (this.props.user.language == "de") choosenLanguage = "de";
              i18n.changeLanguage(choosenLanguage);
              this.props.changeLanguage(choosenLanguage);
            } else {
              if (i18n.language == "fr") choosenLanguage = "fr";
              if (i18n.language == "de") choosenLanguage = "de";
              this.props.changeLanguage(choosenLanguage);
            }
          } else {
            if (i18n.language == "fr") choosenLanguage = "fr";
            if (i18n.language == "de") choosenLanguage = "de";
            this.props.changeLanguage(choosenLanguage);
          }
        } else {
          if (i18n.language == "fr") choosenLanguage = "fr";
          if (i18n.language == "de") choosenLanguage = "de";
          this.props.changeLanguage(choosenLanguage);
        }
        if (subPage !== "") {
          this.props.props.history.push(
            `/${choosenLanguage}/${sPage}/${subPage}`
          );
        } else {
          this.props.props.history.push(`/${choosenLanguage}/${sPage}`);
        }
      }
    }
    this.setState({ currLan: choosenLanguage });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
    const { isAuthenticated } = this.props.props;
    if (this.state.isAuthenticated !== isAuthenticated) {
      this.setState({ isAuthenticated });
    }
    if (this.state.login || this.state.register) {
      if (isAuthenticated) {
        this.setState({
          login: false,
          register: false,
          isOpen: false,
        });
        this.props.changePage("home");
        this.props.props.clearErrors();
      }
    }
    if (this.props.image !== undefined) {
      if (this.props.image.images !== undefined) {
        if (this.props.image.images !== this.state.images) {
          this.setState({ images: this.props.image.images });
        }
      }
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  displayPage = (e, pageTitle) => {
    e.preventDefault();
    this.props.changePage(pageTitle);
  };

  getLangTxt = () => {
    switch (this.state.currLan) {
      case "de":
        return "DE";
      case "fr":
        return "FR";
      default:
        return "EN";
    }
  };

  render() {
    return (
      <Fragment>
        {this.props.auth ? (
          this.props.auth.acceptCookies === null ? (
            <div
              style={{
                height: "30vh",
                maxHeight: "600px",
                position: "fixed",
                zIndex: 60,
                bottom: "0",
                backgroundColor: "#0000009c",
                color: "#fff",
                width: "100%",
                padding: "1rem",
              }}
            >
              <div style={{ maxWidth: "700px", margin: "auto" }}>
                <div>
                  <Translation str={"HeaderCookies"} />{" "}
                  <div>
                    <InlineLink
                      onClick={(e) => {}}
                      filter={`https://www.luckiwi.com/${this.state.currLan}/cookies`}
                      style={{
                        color: "#fff",
                      }}
                    >
                      <Translation str={"HeaderLearnMore"} />
                    </InlineLink>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "0.4rem",
                  }}
                >
                  <Button
                    className="btn-submit"
                    onClick={(e) => {
                      this.props.acceptCookies(false);
                    }}
                  >
                    <Translation str={"HeaderDecline"} />
                  </Button>
                  <Button
                    className="btn-submit"
                    onClick={(e) => {
                      window["ga-disable-G-218QT8EDCS"] = false;
                      window.dataLayer = window.dataLayer || [];
                      function gtag() {
                        window.dataLayer.push(arguments);
                      }

                      gtag("js", new Date());
                      gtag("config", "G-218QT8EDCS");

                      this.props.acceptCookies(true);
                    }}
                  >
                    <Translation str={"HeaderAccept"} />
                  </Button>
                </div>
              </div>
            </div>
          ) : null
        ) : null}
        <header>
          <Navbar bg="light" expand="md" fixed="top">
            <ProfileLink
              onClick={(e) => {
                // this.displayPage(e, "home");
                this.setState({ isOpen: false });
              }}
              filter={
                this.props.props.isAuthenticated
                  ? "/home"
                  : this.state.isSubPage
                  ? "https://www.luckiwi.com/"
                  : `https://www.luckiwi.com/`
              }
            >
              <img
                src={`/../img/logo.webp`}
                alt={"logo"}
                style={{
                  height: "60px",
                }}
              />
            </ProfileLink>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-0 ms-auto">
                <NavDropdown
                className="header-borderleft "
                  title={<Translation str={"HeaderOffer"} />}
                >
                  {_.map(this.state.offer, (tval, tind) => {
                    return (
                      <div
                        className={"hoverMenu buttonContainerStart"}
                        key={tind}
                      >
                        <NavigationLinkAbs
                          navLinkClicked={() => {
                            this.setState({ isOpen: false });
                          }}
                          filter={`https://www.luckiwi.com/${this.state.currLan}/${tval.filter}`}
                        >
                          <Translation str={tval.trans} />
                        </NavigationLinkAbs>
                      </div>
                    );
                  })}
                </NavDropdown>
                <NavDropdown
                  title={<Translation str={"HeaderSoftware"} />}
                >
                  {_.map(this.state.solutions, (tval, tind) => {
                    return (
                      <div
                        className={"hoverMenu buttonContainerStart"}
                        key={tind}
                      >
                        <NavigationLinkAbs
                          navLinkClicked={() => {
                            this.setState({ isOpen: false });
                          }}
                          filter={
                            tind === 0
                              ? `https://www.luckiwi.com/${this.state.currLan}/solutions`
                              : `https://www.luckiwi.com/${this.state.currLan}/solutions/${tval.filter}`
                          }
                        >
                          <Translation str={tval.trans} />
                        </NavigationLinkAbs>
                      </div>
                    );
                  })}
                </NavDropdown>
                {/* <NavigationLink
                  navLinkClicked={() => {
                    this.setState({ isOpen: false });
                  }}
                  filter={`https://luckiwi.com/${this.state.currLan}/pricing`}
                >
                  <Translation str={"HeaderPricing"} />
                </NavigationLink> */}
                <NavigationLinkAbs
                  navLinkClicked={() => {
                    this.setState({ isOpen: false });
                  }}
                  filter={`https://app.luckiwi.com/${this.state.currLan}/contact`}
                >
                  <span>
                    <Translation str={"HeaderContact"} />
                  </span>
                </NavigationLinkAbs>
                <NavDropdown
                  title={
                    <span>
                      <img
                        src={"/img/world.svg"}
                        alt="language"
                        style={{ width: "20px" }}
                      />{" "}
                      {this.getLangTxt()}
                    </span>
                  }
                  id="basic-nav-dropdown"
                  className="header-borderleft"
                >
                  {_.map(this.state.languages, (tval, tind) => {
                    return (
                      <NavDropdown.Item
                        className={"hoverMenu buttonContainerStart"}
                        style={{
                          backgroundColor:
                            this.state.currLan === tval ? "#d6d6d6" : "",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({ currLan: tval, isOpen: false });
                          i18n.changeLanguage(tval);
                          this.props.changeLanguage(tval);

                          let domainPath = "";
                          if (window.location)
                            if (window.location.pathname)
                              domainPath = window.location.pathname;

                          let subdomain = [];
                          subdomain = domainPath.split("/");
                          let sLan = "en";
                          let sPage = "";
                          if (subdomain.length > 0)
                            if (subdomain[0] === "") subdomain.shift();

                          if (
                            subdomain[0] === "fr" ||
                            subdomain[0] === "en" ||
                            subdomain[0] === "de"
                          ) {
                            sLan = subdomain[0];
                            if (subdomain[1] && subdomain[1] !== "")
                              sPage = subdomain[1];
                          } else {
                            sPage = subdomain[0];
                          }

                          if (tval != sLan) {
                            this.props.props.history.push(`/${tval}/${sPage}`);
                          }
                        }}
                        key={tind}
                      >
                        <span
                          style={{ marginLeft: "0.25rem", cursor: "pointer" }}
                        >
                          {tval === "en" ? (
                            <>
                              <img
                                src={`/../img/english.webp`}
                                style={{
                                  height: "30px",
                                  margin: "0 10px 0 5px",
                                }}
                                alt="logo angleterre"
                              />
                              <span>English</span>
                            </>
                          ) : tval === "de" ? (
                            <>
                              <img
                                src={`/../img/german.webp`}
                                style={{
                                  height: "30px",
                                  margin: "0 10px 0 5px",
                                }}
                                alt="logo allemagne"
                              />
                              <span>Deutsch</span>
                            </>
                          ) : (
                            <>
                              <img
                                src={`/../img/french.webp`}
                                alt="logo france"
                                style={{
                                  height: "30px",
                                  margin: "0 10px 0 5px",
                                }}
                              />
                              <span>Français</span>
                            </>
                          )}
                        </span>
                      </NavDropdown.Item>
                    );
                  })}
                </NavDropdown>
                <NavigationLink
                  navLinkClicked={() => {
                    this.setState({ isOpen: false });
                  }}
                  filter={`./${this.state.currLan}/login`}
                >
                  <Translation str={"HeaderLogin"} />
                </NavigationLink>
                {window.location.host.split(".")[1] ? (
                  window.location.host.split(".")[0] === "app" ? (
                    <NavigationLink
                      navLinkClicked={() => {
                        this.setState({ isOpen: false });
                      }}
                      filter={`./${this.state.currLan}/register`}
                      id="headerForBackground"
                    >
                      <span id="backgrounded">
                        {" "}
                        <Translation str={"HeaderRegister"} />
                      </span>
                    </NavigationLink>
                  ) : null
                ) : (
                  <NavigationLink
                    navLinkClicked={() => {
                      this.setState({ isOpen: false });
                    }}
                    id="headerForBackground"
                    filter={`./${this.state.currLan}/register`}
                  >
                    <span id="backgrounded">
                      <Translation str={"HeaderRegister"} />
                    </span>
                  </NavigationLink>
                )}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </header>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  page: state.page,
  isAuthenticated: state.auth.isAuthenticated,
  image: state.image,
  user: state.user,
});

export default connect(mapStateToProps, {
  changePage,
  clearErrors,
  getProjects,
  logout,
  resetAuthUser,
  changeLanguage,
  acceptCookies,
})(HeaderLoggedOut);
